module.exports = __webpack_public_path__ + "static/img/5779_phase_function_Paper_Points.c1f4ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5779_phase_function_Paper_Points.png
// module id = nEe2
// module chunks = 0